import { CSSProperties, FC, HTMLProps, ReactNode } from 'react'

interface InlineProps extends HTMLProps<HTMLDivElement> {
	children: ReactNode
	align?: 'flex-start' | 'center' | 'flex-end'
	justify?: 'start' | 'end' | 'center' | 'space-between' | 'around' | 'evenly'
	gap?: number
	style?: CSSProperties
}

export const Inline: FC<InlineProps> = ({ children, align, justify, gap, style, ...rest }) => {
	return (
		<div
			{...rest}
			style={{
				display: 'flex',
				justifyContent: justify,
				alignItems: align,
				columnGap: gap,
				overflowX: 'auto',
				scrollbarWidth: 'none',
				...style,
			}}>
			{children}
		</div>
	)
}
